import React, { useEffect } from 'react'
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { useStore } from "../../store/store";
import fractionToInt from '../../util/fractionToInt';
import pivotPointOptions from './pivotPointOptions';

const usePivotPointSelector = () => {
    const addToQuote = useStore((state) => state.addToQuote);

    const pivotPoint = useStore((state) => state.quote.pivotPoint);
    const pivotHardware = useStore((state) => state.quote.pivotHardware);
  
    const swingPanelWidth = useStore((state) => state.quote.swingPanelWidth);
    const swingPanelFraction = useStore(
      (state) => state.quote.swingPanelFraction,
    );
  
    const overall = fractionToInt(swingPanelWidth || "", swingPanelFraction);
  
    const findRequired = useRequiredMsgs((state) => state.findRequired);
    const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  
    const handleClick = (label: string) => {
      const checked = label === pivotPoint;
  
      if (checked) {
        addToQuote({ pivotPoint: "" }, "pivotPoint");
      } else {
        addToQuote({ pivotPoint: label });
        if (findRequired("Pivot Point")) {
          removeRequired("Pivot Point");
        }
      }
    };
  
    const variant = (label: string) =>
      label === pivotPoint ? "filled" : "outlined";
  
    const checkMark = (label: string) => label === pivotPoint;
  
    const pivots = pivotPointOptions(pivotHardware || "", overall);
  
    useEffect(() => {
      if (!pivots?.length || !overall) return;
  
      if (overall < 24) return;
  
      const included = pivots.filter((p) => p.label === pivotPoint);
      if (!included.length) {
        addToQuote({ pivotPoint: "" });
      }
    }, [pivots]);
  
    const imgLabel = !pivotPoint
      ? ""
      : pivotPoint.includes("Middle")
        ? "Middle_bold"
        : pivotPoint.includes("16")
          ? "16_bold"
          : pivotPoint.includes("12")
            ? "12_bold"
            : pivotPoint.includes("8")
              ? "8_bold"
              : "4.75_bold";

    return {
        imgLabel,
        checkMark,
        variant,
        handleClick,
        overall,
        pivotHardware,
        pivots,
        pivotPoint
    }
}

export default usePivotPointSelector